import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-loading-snackbar',
  templateUrl: './loading-snackbar.component.html',
  styleUrl: './loading-snackbar.component.scss'
})
export class LoadingSnackbarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public message: string) { }

}
